import { writable } from "svelte/store";

const createState = () => ({
	visible: false,
	message: "",
	labels: [],
	resolve: null,
});

const { subscribe, update, set } = writable(createState());

export default {
	subscribe,
	open: (message, labels = ["閉じる"]) => {
		return new Promise((resolve) => {
			set({
				visible: true,
				message,
				labels,
				resolve,
			});
		});
	},
	close: (payload) => {
		update((state) => {
			state.resolve(payload);
			return createState();
		});
	},
};
